export const CORE_INVENTORY_REQUEST = "CORE_INVENTORY_REQUEST";
export const CORE_INVENTORY_SUCCESS = "CORE_INVENTORY_SUCCESS";
export const CORE_INVENTORY_FAILED = "CORE_INVENTORY_FAILED";
export const CORE_HISTORY_REQUEST = "CORE_HISTORY_REQUEST";
export const CORE_HISTORY_SUCCESS = "CORE_HISTORY_SUCCESS";
export const CORE_HISTORY_FAILED = "CORE_HISTORY_FAILED";
